import api from "./http";

export const ApiBelanja = {
    getAll : (nuwb)=>{
        return api.get(`/cakepin/belanja/${nuwb}`)
    },
    post : (data)=>{
        return api.post(`/cakepin/belanja`,data)
    }
}